import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=821c3e50"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"
import style0 from "./Proveedores.vue?vue&type=style&index=0&id=821c3e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports